import { FavouritesEmptyState } from 'app/components/favourites-empty-state';
import { Text } from 'app/design/primitives/text';
import type { Listing } from 'app/types/listing';
import { Strategies } from '../../all-listings/components/recommended-listings.utils';
import { DesktopRecommendationSection } from '../../all-listings/components/recommended-listings.large';
import { landingPageLargeStyles as styles } from '../large-styles';
import type { useDesktopLandingData } from '../use-desktop-landing-data';

export function FavouritesDiscoverySection({ data }: { data: ReturnType<typeof useDesktopLandingData> }) {
  const { actions, favouritesRecommendations, shouldShowRecommendationSection, t } = data;
  if (!shouldShowRecommendationSection(favouritesRecommendations, { hasEmptyState: true })) return null;
  return (
    <DesktopRecommendationSection
      horizontalPadding={0}
      strategyProps={{ strategy: Strategies.YourFavourites }}
      recommendationState={favouritesRecommendations}
      recommendations={favouritesRecommendations.recommendations as Listing[] | undefined}
      onViewAll={actions.openFavourites}
      emptyState={
        <FavouritesEmptyState
          buttonText={t('your-favourites.emptyStateButton')}
          onExplore={actions.openExploreOffers}
          title={t('your-favourites.emptyStateTitle')}
          subtitle={t('your-favourites.emptyStateText')}
        />
      }
      titleSuffix={<Text style={styles.headerIcon}>❤️</Text>}
    />
  );
}
